import { useEffect, useState } from 'react';
import { mergeEvent, type LiveEvent, type LiveTopic, type StreamStatus } from './liveModel';
import { LiveStreamRunner } from './liveStreamRunner';

export type { LiveEvent, LiveTopic, StreamStatus } from './liveModel';

/**
 * Subscribes to GET /v1/stream?topics=… with the bearer header (fetch + ReadableStream), keeps the newest `cap`
 * events, resumes with Last-Event-ID, backs off on failure and reconnects when heartbeats stop.
 */
export function useLiveStream(topics: LiveTopic[], cap = 50) {
  const [status, setStatus] = useState<StreamStatus>('connecting');
  const [events, setEvents] = useState<LiveEvent[]>([]);
  const [error, setError] = useState<string | null>(null);
  const key = topics.join(',');

  useEffect(() => {
    const runner = new LiveStreamRunner(key, {
      onStatus: setStatus,
      onError: setError,
      onEvent: (ev) => setEvents((prev) => mergeEvent(prev, ev, cap)),
    });
    runner.start();
    return () => runner.dispose();
  }, [key, cap]);

  return { status, events, error };
}
